/* istanbul ignore file */

import { CdkScrollable } from '@angular/cdk/scrolling';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';

import { ColumnComponent, GridComponent, GridDataResult } from '@progress/kendo-angular-grid';

import { DialogHeaderComponent } from 'src/app/shared/components/dialog-header/dialog-header.component';
import { Site } from '../../../../../models';
import { AppsService } from '../../../../../services';
import { AppAliasService } from '../../../../../services/logic-services';
import { AppFlatButtonComponent } from '../../../../buttons/app-flat-button/app-flat-button.component';
import { AppTextButtonComponent } from '../../../../buttons/app-text-button/app-text-button.component';

@Component({
    selector: 'kh-excel-bulk-site-upload-duplicate-sites-dialog',
    templateUrl: './excel-bulk-site-upload-duplicate-sites-dialog.component.html',
    styleUrls: ['./excel-bulk-site-upload-duplicate-sites-dialog.component.scss'],
    imports: [
        AppFlatButtonComponent,
        AppTextButtonComponent,
        CdkScrollable,
        ColumnComponent,
        DialogHeaderComponent,
        GridComponent,
        MatDialogActions,
        MatDialogClose,
        MatDialogContent,
        MatDialogTitle
    ]
})
export class ExcelBulkSiteUploadDuplicateSitesDialogComponent implements OnInit {
    gridData: GridDataResult;
    siteNumberTitle = `${this.siteAlias} number`;

    get sitesAliasLowerCase(): string {
        return this._appAliasService.sitesAliasLowerCase;
    }

    get siteAliasLowerCase(): string {
        return this._appAliasService.siteAliasLowerCase;
    }

    get siteAlias(): string {
        return this._appsService.currentApp.aliases.site.singular;
    }

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: Site[],
        private _appAliasService: AppAliasService,
        private _appsService: AppsService,
        public dialogRefDuplicate: MatDialogRef<ExcelBulkSiteUploadDuplicateSitesDialogComponent>,
    ) { }
    ngOnInit(): void {
        this.loadData();
    }

    loadData(): void {
        this.gridData = {
            data: this.data,
            total: this.data.length
        };
    }

    closeDialog(): void {
        this.dialogRefDuplicate.close(false);
    }

    onConfirm(): void {
        this.dialogRefDuplicate.close(true);
    }
}
